module.exports = __webpack_public_path__ + "static/media/adminpanel-logo-white.0010f762.svg";